// extracted by mini-css-extract-plugin
export default {"info":"Other_info__nmesk","title":"Other_title__05Qzl","actions":"Other_actions__nqs6g","cancelBtn":"Other_cancelBtn__gy9y0"};